/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React from 'react';
import LazyLoad from 'react-lazyload';
import ImgCrop from '../../../Common/ImgCrop';
import StatsBar from '../../../Common/StatsBar';
import Sponsor from '../../../Common/Sponsor';
import {
  getStatsBarData,
  getSponsorData,
  createTagList,
  transformUpsellData,
} from '../../../../utils/utils';
import { CONTENT_TYPE } from '../../../../constants/globalConstants';
import { COLLECTION_MODAL } from '../../../../constants/containerConstants';
import UpSell from '../../../Common/UpSell';

const Image = ({ data, index }) => {
  return (
    <React.Fragment>
      <Sponsor
        contentType={data.contenttype_t}
        varient={data.variant_t}
        sponsorInfo={data.sponsordetailinfo_s}
        grid={'grid-12'}
        type={CONTENT_TYPE}
        author={data.authorname_s}
        cardName={data.teaser_t || data.blogdescription_t}
        container={COLLECTION_MODAL}
        createdDateTime={data.appearance_tdt || data.__published_tdt}
        itemId={data.itemid_s}
        tags={createTagList(data.taglist_sm, data.category_s)}
      ></Sponsor>
      <div className="grid-8 ratio centeritem">
        <div className="mu-content">
          <article className="mu-item image">
            <div className="img-holder">
              {data && data.imagecropurl_s && (
                <LazyLoad once={true} offset={100}>
                  <ImgCrop
                    imgCrop={data.imagecropurl_s}
                    alt=""
                    title=""
                    isWebpAvailable={data.iswebpavailablebool_b}
                  ></ImgCrop>
                </LazyLoad>
              )}
            </div>
          </article>
        </div>
      </div>
      <div className="mu-modal__body__description">
        <p className="mu-item__teasure" tabIndex="0">
          <i className="icon-camera-white"></i>
          {data.teaser_t || data.blogdescription_t}
          <span className="screenreader">{data.contenttype_t}</span>
        </p>
        {data.upsell_s && <UpSell data={transformUpsellData(data.upsell_s)} />}
      </div>
      <StatsBar
        item={getStatsBarData(data)}
        upSellData={data.upsell_s && transformUpsellData(data.upsell_s)}
      ></StatsBar>
    </React.Fragment>
  );
};
export default Image;
